/**
 * Converts a Date object to ISO date string (YYYY-MM-DD)
 * @param {Date} date - The date to convert
 * @returns {string} ISO date string
 */
export const toISODateString = (date) => {
  return date.toISOString().split('T')[0];
};

/**
 * Gets today's date as ISO string
 * @returns {string} Today's date in YYYY-MM-DD format
 */
export const getTodayISO = () => {
  return new Date().toISOString().split('T')[0];
};

/**
 * Formats a date string for display in Danish locale
 * @param {string} dateStr - ISO date string (YYYY-MM-DD)
 * @param {object} options - Intl.DateTimeFormat options
 * @returns {string} Formatted date string
 */
export const formatDateDK = (dateStr, options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' }) => {
  const date = new Date(dateStr + 'T00:00:00');
  return date.toLocaleDateString('da-DK', options);
};

/**
 * Checks if a date is in the past
 * @param {Date} date - The date to check
 * @returns {boolean} True if date is before today
 */
export const isPastDate = (date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
};

/**
 * Checks if a date is today
 * @param {Date} date - The date to check
 * @returns {boolean} True if date is today
 */
export const isToday = (date) => {
  const today = new Date();
  return date.toDateString() === today.toDateString();
};
